import React from 'react';

const Icon = ({ size = '24', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...other}>
            <path
                d="M12.485 3.313c.38 0 .688.308.688.687v7.313h7.312a.688.688 0 0 1 0 1.375h-7.312v8.283a.688.688 0 0 1-1.376 0v-8.283H3.515a.688.688 0 0 1 0-1.376h8.282V4c0-.38.309-.688.688-.688Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
